import B_Solution from '../../../../base/dev/child/attr/B_Solution';

import BlocklyManager from '../../../../../../../../../../assets/js/codmos/BlocklyManager';
import R_Define from '../../util/R_Define';
import B_Define from '../../../../base/dev/util/B_Define';

const init = () => {
    return class R_Solution extends B_Solution {
        constructor(obj) {
            super(obj);

            this._or = obj.or || null;

            this.CODMOS.WORLD.LIST[B_Define.SOLUTION_TYPE][this.id] = this;
        }

        compare(force) {
            let bool = false;

            switch (this.type) {
                case R_Define.BLOCK_SOLUTION_TYPE: {
                    bool = this._compareBlock();
                    break;
                }
                case R_Define.VARIABLE_SOLUTION_TYPE: {
                    bool = this._compareVariable();
                    break;
                }
                case R_Define.INVENTORY_SOLUTION_TYPE: {
                    bool = this._compareInventory();
                    break;
                }
                default:
            }

            if (
                !force
                && !bool
                && this._or
            ) {
                bool = this.CODMOS.WORLD.LIST[B_Define.SOLUTION_TYPE][this._or].compare(true);
            }

            return bool;
        }

        /**
         * [ Function :: _compareBlock ]
         *
         * @DES :: 블록 솔루션 처리
         * @O.P :: null
         */
        _compareBlock() {
            const { type, expectation } = this.answerSheet.block;
            let bool = false;

            switch (type) {
                case 'use': {
                    // 어느 위치에라도 블록이 존재하면 성공, 단 except 대상 블록 밑에 있을 경우 제외
                    const { block, except } = expectation;
                    const { whenBlocks } = BlocklyManager;
                    let func;
                    if (Array.isArray(except)) {
                        func = (e) => {
                            return !whenBlocks.some((e2) => {
                                return !except.includes(e2) && BlocklyManager.getIsIn(e2, e);
                            });
                        };
                    } else {
                        func = (e) => {
                            return !whenBlocks.some((e2) => {
                                return except !== e2 && BlocklyManager.getIsIn(e2, e);
                            });
                        };
                    }
                    bool = !block.some(func);
                    break;
                }
                case 'count': {
                    // 어느 위치에라도 n 번 이상 사용 되었을 경우 성공
                    const { whenBlocks } = BlocklyManager;
                    for (const key in expectation) {
                        bool = whenBlocks.reduce((a, b) => a + BlocklyManager.getInCount(b, key), 0) >= expectation[key];
                        if (!bool) break;
                    }
                    break;
                }
                case 'count2': {
                    // 특정 위치에 n 번 사용 되었을 경우 성공
                    /* eslint-disable no-labels */
                    outer:for (const key in expectation) {
                        for (const key2 in expectation[key]) {
                            bool = BlocklyManager.getInCount(key, key2) === expectation[key][key2];
                            if (!bool) break outer;
                        }
                    }
                    /* eslint-enable no-labels */
                    break;
                }
                case 'or': {
                    // 모든 when 블록에 알맞은 정답이 하나라도 조립 되어 있을 경우 성공
                    for (const key in expectation) {
                        bool = expectation[key].some(e => BlocklyManager.getIsIn(key, e));
                        if (!bool) break;
                    }
                    break;
                }
                case 'in': {
                    // 모든 when 블록에 알맞은 정답이 조립 되어 있을 경우 성공
                    for (const key in expectation) {
                        bool = !expectation[key].some(e => !BlocklyManager.getIsIn(key, e));
                        if (!bool) break;
                    }
                    break;
                }
                default:
            }

            return bool;
        }

        /**
         * [ Function :: _compareVariable ]
         *
         * @DES :: 변수 솔루션 처리
         * @O.P :: null
         */
        _compareVariable() {
            const { expectation } = this.answerSheet.variable;
            let bool = false;

            for (const key in expectation) {
                const variable = this.CODMOS.WORLD[key];

                if (variable) {
                    const { type, value } = expectation[key];
                    switch (type) {
                        case 'gte': {
                            // 변수의 값이 지정 된 값보다 크거나 같으면 성공
                            bool = variable.getValue() >= value;
                            break;
                        }
                        default:
                    }
                } else {
                    bool = false;
                }
                if (!bool) break;
            }

            return bool;
        }

        /**
         * [ Function :: _compareInventory ]
         *
         * @DES :: 인벤토리 솔루션 처리
         * @O.P :: null
         */
        _compareInventory() {
            const { expectation: { value, type = 'eq' } } = this.answerSheet.inventory;
            const [hero] = Object.values(this.CODMOS.WORLD.LIST[R_Define.HERO_TYPE]);

            let bool = false;

            switch (type) {
                case 'eq': {
                    // 캐릭터가 획득한 힛 아이템 개수와 지정 값이 같아야 정답
                    bool = hero.hitItemCount === value;
                    break;
                }
                case 'gte': {
                    // 캐릭터가 획득한 힛 아이템 개수와 지정 값이 같거나 크면 정답
                    bool = hero.hitItemCount >= value;
                    break;
                }
            }


            return bool;
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/child/attr/R_Solution.js